import { Tier } from 'app/shared/account/tier.model';
import { Currency } from '../shared/account/Currency';

export class LimitationsWithUsage {
  public surveyResponses = new Limitation(0);
  public events = new Limitation(0);
  public persons = new Limitation(0);
  public automations = new Limitation(0);
  public batchRecords = new Limitation(0);
  public batchRecordsPerMonth = new Limitation(0);
  public users = new Limitation(0);
  public id?: string;

  constructor(limitations: Limitations) {
    this.id = limitations.id;
  }
}

export interface SubscriptionDetails {
  currency?: Currency;
  price?: number;
  discountedPrice?: number;
  discount?: SubscriptionDiscount;
  billingFrequency?: SubscriptionFrequency;
  currentPeriodEnd?: string;
  card?: SubscriptionDetailsCard;
  billingEmail?: string;
  cancelAtPeriodEnd: boolean;
  taxLocationCountry: string;
  status: string;
  endedAt?: number;
  pendingConfirmationUrl?: string;
}

export interface SubscriptionDiscount {
  percentOff?: number;
  amountOff?: number;
  endDate?: string;
}

export enum SubscriptionProvider {
  Stripe = 'Stripe',
  Shopify = 'Shopify',
}

export interface ConvertToShopifyResponse {
  customerId: string;
  converted: boolean;
  requiresManualMigration: boolean;
  message?: string;
}

export enum AppSubscriptionStatus {
  Pending = 'Pending',
  Active = 'Active',
  Cancelled = 'Cancelled',
  Expired = 'Expired',
  Declined = 'Declined',
  Frozen = 'Frozen',
  Accepted = 'Accepted',
}

export interface ShopifyAppChargeResponse {
  confirmationUrl: string;
}

export interface SubscriptionDetailsCard {
  brand?: string;
  last4?: string;
}

export enum SubscriptionFrequency {
  Month = 'Month',
  Year = 'Year',
}

export interface ManangeSubscriptionResponse {
  url: string;
}

export interface CalculateSubscriptionPriceRequest extends UpdateSubscriptionPriceRequest {
  currency: Currency;
}

export interface UpdateSubscriptionPriceRequest {
  tier?: Tier;
  billingFrequency: SubscriptionFrequency;
  eventsPerMonth: number;
  accounts: number;
  surveyResponsesPerMonth: number;
  testPrice?: number;
}

export class Limitation {
  value?: number;

  constructor(public max: number) {}
}

export interface Limitations {
  id?: string;
  resetDayInMonth?: number;
  importExportRowsPerMonth?: number;
  eventsPerMonth?: number;
  users?: number;
  accounts?: number;
  surveyResponsesPerMonth?: number;
  emailsPerMonth?: number;

  /** Monthly Public API cap. Undefined means no customer override; the UI falls back to a runtime default. */
  publicApiCallsPerMonth?: number;
}

export interface StorageLimitations {
  tier?: Tier;
  eventsPerMonth?: number;
  accounts?: number;
  surveyResponsesPerMonth?: number;
}

export interface TierLimitations {
  events: number[];
  surveyResponses: number[];
  defaultSurveyResponses: number;
  defaultAiChatCredits: number;
}

export interface AiChatUsage {
  /** Includes cachedInputTokens. */
  inputTokens: number;
  cachedInputTokens: number;
  outputTokens: number;
  messagesSent: number;
  creditsUsed: number;
  creditsLimit: number;
  percentUsed: number;
  periodEnd: string;
}

export interface AiChatUsageSummary {
  percentUsed: number;
  periodEnd: string;
}

export interface PublicApiCallsUsage {
  used: number;
  /** Effective limit: the customer override when set, otherwise the backend runtime default. */
  limit: number;
  periodEnd: string;
}
